export default "__VITE_ASSET__BAqhd$l5__"